export interface SurveyDefinition {
  id: string;
  title: string;
  description: string;
  formUrl: string;
  formId: string;
  registrationReferenceQuestionId: string;
  tournamentIds: string[];
  entries: {
    registrationReference: string;
    teamName: string;
    teamCaptain: string;
    tournament: string;
  };
}

export interface RegistrationSurvey {
  id: string;
  title: string;
  description: string;
  url: string;
  completed: boolean;
}

export const SURVEY_COPY = {
  title: 'Tournament survey',
  description: 'Help us plan tournament day. One response per team.',
  pending: 'Survey needed',
  button: 'Complete survey',
  buttonAccessibleLabel: 'Complete survey (opens in a new tab)',
  completed: 'Survey completed',
  modalTitle: 'Registration submitted',
  modalBody:
    'Please complete this short survey to help us plan tournament day. We need one response per team.',
  invalidConfig: 'The survey settings are invalid.',
  invalidSubmission: 'The survey response is invalid.',
  invalidCallback: 'The survey submission could not be verified.',
  invalidReference: 'The registration reference is invalid.',
  registrationNotFound: 'No registration matches this survey response.',
} as const;

export const SURVEY_STAFF_COPY = {
  action: 'Watch form',
  homeDescription: 'Connect a survey to a tournament.',
  formUrlLabel: 'Google Form ID or editor link',
  tournamentsLabel: 'Tournaments',
  pending: 'Adding survey…',
  success: 'Survey added.',
  invalidUrl: 'Enter a valid Google Form ID or editor link.',
  accessError:
    'We couldn’t access this form. Check that it’s shared with the portal service account.',
  missingQuestion:
    'Add a short-answer question named “{questionName}” to the form.',
  duplicateQuestion:
    'The form has more than one question named “{questionName}”. Keep one.',
  requiredReference:
    'Make “Registration Reference” a required question in the form.',
  invalidPrefill: 'The prefill settings do not match the form questions.',
  invalidTournament: 'Choose a valid tournament.',
  tournamentConflict: 'This tournament already has another survey.',
  readError: 'The form could not be checked. Try again.',
  saveError: 'The survey could not be saved. Try again.',
} as const;
